module.exports = __webpack_public_path__ + "font/ebf6d1640ccddb99fb49f73c052c55a8.woff2";